import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';

import Button from './button';

export interface CopyButtonProps {
  url: string;
  displayValue?: string;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class DownloadButton extends React.Component<CopyButtonProps> {
  public render() {
    const { url, displayValue } = this.props;

    return (
      <a href={url} download target="_blank" rel="noopener noreferrer">
        <Button text={displayValue || 'Download'} icon={faCloudDownloadAlt} slimButton type="button" />
      </a>
    );
  }
}
